export default __webpack_public_path__ + "static/media/0abbd190e57b3ab90148f244fdfdda27.svg";